import _ from 'underscore';
import Backbone from 'backbone';
import CoreModel from 'core/models/core';


// QuestionLog model
export default CoreModel.extend({
  urlRoot: QUESTIONLOG_API_URL,
  question: null,

  initialize: function (attributes, options) {
    // Pass the Question model in as an option to enable validation
    if (options && _.contains(_.keys(options), 'question')) {
      this.question = options.question;
    }
  },

  validate: function (attributes, options) {
    if (this.question && this.question.get('is_required')) {
      if (!_.contains(_.keys(attributes), 'value') ||
                      attributes.value === null || attributes.value === '') {
        return 'This item is required.';
      }
    }
  }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/screener-app/screener/static/js/screener/models/question_log.js
// module id = 38
// module chunks = 0